import { useState } from "react";

import { usePlaylist } from "./usePlaylistContext";

interface SwipeNavOptions {
  threshold?: number;
}

export const useSwipeNavigation = ({
  threshold = 50,
}: SwipeNavOptions = {}) => {
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const { currentMediaIndex, setCurrentMediaIndex, mediaItems } = usePlaylist();

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.touches[0]?.clientX ?? null);
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStart === null) return;

    const touchEnd = e.changedTouches[0]?.clientX ?? null;
    const diff = touchStart - (touchEnd ?? 0);

    if (Math.abs(diff) > threshold) {
      if (diff > 0 && currentMediaIndex < mediaItems.length - 1) {
        // Swipe left - go to next item
        setCurrentMediaIndex(currentMediaIndex + 1);
      } else if (diff < 0 && currentMediaIndex > 0) {
        // Swipe right - go to previous item
        setCurrentMediaIndex(currentMediaIndex - 1);
      }
    }

    setTouchStart(null);
  };

  return {
    handleTouchStart,
    handleTouchEnd,
  };
};
